import * as React from "react";
import type { FeatureNavModule, FeatureRouteModule } from "../types";
import { Plug } from "lucide-react";
import { IntegrationsPage } from "@/pages/integrations";
import { ConnectionDetailPage } from "@/pages/connection-detail";

export const integrationsRoutes: FeatureRouteModule = {
  shellRoutes: [
    {
      path: "integrations",
      handle: { title: "Integrations" },
      element: React.createElement(IntegrationsPage),
    },
    {
      // Opened from a card on the Connected tab. A row the list no longer holds says so
      // rather than rendering an empty page.
      path: "integrations/connections/:connectionId",
      handle: { title: "Connection" },
      element: React.createElement(ConnectionDetailPage),
    },
  ],
  shellRouteDefs: [
    {
      path: "/integrations",
      title: "Integrations",
      summary:
        "Setup guides for the external systems this project works with, and the connections it holds.",
    },
  ],
};

export const integrationsNav: FeatureNavModule = {
  navGroups: [
    {
      label: "Build",
      items: [{ to: "/integrations", label: "Integrations", icon: Plug, end: false }],
    },
  ],
};
